import { CircularProgress, Typography } from '@mui/material'
import { commify, formatUnits } from 'ethers/lib/utils'
import { useAtomValue } from 'jotai'
import React, { useState } from 'react'
import { erc20ABI, useAccount, useContractReads } from 'wagmi'
import { TargetChainAtom } from '../common/atoms'
import { SupportedTicker, TICKERS_FILTER_BY_CHAIN } from '@/constants/token'

const EvmBalance = ({ tickerName }: { tickerName: SupportedTicker }) => {
  const [evmBalanceMap, setEvmBalanceMap] = useState<any>()

  const { address: evmAccount } = useAccount()

  const targetChain = useAtomValue(TargetChainAtom)

  const tickersSupportedOnTargetChain = TICKERS_FILTER_BY_CHAIN[targetChain]

  const { isFetching: isEvmBalanceFetching } = useContractReads({
    contracts: tickersSupportedOnTargetChain.map((ticker) => ({
      address: ticker.erc20Tokens[targetChain].address,
      abi: erc20ABI,
      functionName: 'balanceOf',
      chainId: targetChain,
      args: [evmAccount],
    })),
    enabled: !!evmAccount,
    onSuccess(data) {
      data.forEach((result, index) => {
        const ticker = tickersSupportedOnTargetChain[index]
        setEvmBalanceMap((currentMap) => ({
          ...currentMap,
          [ticker.name]: { ...result, decimal: ticker.erc20Tokens[targetChain].decimal },
        }))
      })
    },
  })

  if (isEvmBalanceFetching) {
    return <CircularProgress size={20} />
  } else if (evmBalanceMap?.[tickerName]?.status === 'success') {
    const tokenData = evmBalanceMap?.[tickerName]
    return <Typography>{commify(Number(formatUnits(tokenData.result, tokenData.decimal)).toFixed(2))}</Typography>
  } else {
    return <Typography>0</Typography>
  }
}

export default EvmBalance
